import { render, staticRenderFns } from "./answerPage.vue?vue&type=template&id=37300ad4"
import script from "./answerPage.vue?vue&type=script&lang=js"
export * from "./answerPage.vue?vue&type=script&lang=js"
import style0 from "./answerPage.vue?vue&type=style&index=0&id=37300ad4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports